//Services
import { getReq, postReq } from 'src/services/http';
//Types
import type {
	RequestStatisticData,
	GetStatsPeriodRequest,
} from 'src/types/requests/charts/get_stats_period';

let instance: CacheStatisticRequest;
class CacheStatisticRequest {
	private TIMEOUT = 60 * 1000;
	private cacheStatisticData: {
		timestamp: number;
		reqURL: string;
		reqData: RequestStatisticData;
		resData: any;
	}[];
	constructor() {
		if (!instance) {
			this.cacheStatisticData = [];
			instance = this;
		}
	}
	public clear = (): void => {
		this.cacheStatisticData = [];
	};
	public async getData(
		reqURL: string,
		reqData: RequestStatisticData,
		instance: string = undefined,
		strongCache = false,
		postReqest = false,
	): Promise<any> {
		this.cacheStatisticData = this.cacheStatisticData.filter(
			(i) => i.timestamp > Date.now() - this.TIMEOUT,
		);
		const cacheResult = this.cacheStatisticData.find(
			(i) => i.reqURL == reqURL && JSON.stringify(i.reqData) === JSON.stringify(reqData),
		);
		if (cacheResult) {
			return cacheResult.resData;
		}
		const cacheStatisticData = {
			timestamp: strongCache === true ? Number.MAX_VALUE : Date.now(),
			reqURL,
			reqData,
			resData: new Promise(async (resolve) => {
				const reqestMethod = postReqest ? postReq : getReq;
				const res: GetStatsPeriodRequest = (await reqestMethod(
					reqURL,
					reqData,
					20000,
					instance,
				)) as GetStatsPeriodRequest;
				if ((res?.error || !res?.isok) && !res?.history && !res?.report) {
					cacheStatisticData.timestamp = 0;
				}
				resolve(res);
			}),
		};
		this.cacheStatisticData.push(cacheStatisticData);
		return cacheStatisticData.resData;
	}
}

export default new CacheStatisticRequest();
